import * as m from 'mithril';
import * as dayjs from 'dayjs';
import './Calendar.css';
import CustomSvgIcon from './CustomSvgIcon';

class DayCell {
    date: string;
    day: string;
    selectable: boolean;
    isInCurrentMonth: boolean;

    constructor(date: string, day: string, isInCurrentMonth: boolean, selectable: boolean) {
        this.date = date;
        this.day = day;
        this.selectable = selectable;
        this.isInCurrentMonth = isInCurrentMonth;
    }
}

class Week {
    days: DayCell[]
    constructor(days: DayCell[]) {
        this.days = days;
    }
}

export function MultipleMonthCalendarView(): m.Component<{ startYear: number, startMonth: number, numberOfMonths: number }> {
    return {
        view(vnode) {
            let yearMonthArray: any[] = [];

            let year = vnode.attrs.startYear;
            let month = vnode.attrs.startMonth;
            let i: number = 0;
            while (i < vnode.attrs.numberOfMonths) {
                yearMonthArray.push({
                    year: year,
                    month: month
                });

                month = month + 1;
                if (month > 12) {
                    month = 1;
                    year = year + 1;
                }
                i++;
            }

            return m("div.row",
                yearMonthArray.map(yearMonth => {
                    return m("div.col-4",
                        m(SingleMonthCalendarView, {
                            year: yearMonth.year,
                            month: yearMonth.month,
                            titleVisible: true,
                            onDateSelected: (date: string) => { }
                        })
                    );
                })
            )
        }
    }
}

interface SingleMonthCalendarViewAttrs {
    year: number,
    month: number,
    titleVisible: boolean,
    selectedDate?: string | null,
    minDate?: string | null,
    maxDate?: string | null,
    onDateSelected: (date: string) => void
}

export function SingleMonthCalendarView(): m.Component<SingleMonthCalendarViewAttrs> {
    return {
        view(vnode) {
            //console.log("SingleMonthCalendarView", vnode.attrs);

            let monthIndex = vnode.attrs.month - 1;
            let monthStartDate = new Date(vnode.attrs.year, monthIndex, 1);
            let anchorDayjsObj = dayjs(monthStartDate); //.format("YYYY-MM-DD");

            let currMonthStartDate = anchorDayjsObj.startOf("month").format("YYYY-MM-DD");
            let currMonthEndDate = anchorDayjsObj.endOf("month").format("YYYY-MM-DD");

            let calStartDayJsObj = anchorDayjsObj.startOf("month").startOf("week");
            let currViewStartDate = calStartDayJsObj.format("YYYY-MM-DD");
            let currViewEndDate = calStartDayJsObj.add(41, 'day').format("YYYY-MM-DD"); //6 weeks = 42 days (0 to 41 in terms of index)

            //return m("h1", dateStr);
            let currMonthStartDayjsObj = dayjs(currMonthStartDate);
            let currMonthEndDayjsObj = dayjs(currMonthEndDate);

            let monthYearLabel = currMonthStartDayjsObj.format("MMMM, YYYY");
            let dayLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

            let numWeeks = 6;
            let numDaysInWeek = 7;

            let weeks: Week[] = new Array(numWeeks);

            for (let i: number = 0; i < numWeeks; i++) {
                let days: DayCell[] = [];
                for (let j: number = 0; j < numDaysInWeek; j++) {
                    let dateDayjsObj = dayjs(currViewStartDate).add(i * numDaysInWeek + j, 'day');
                    let date: string = dateDayjsObj.format("YYYY-MM-DD");
                    let day: string = dateDayjsObj.format("D");

                    let isInCurrentMonth: boolean = (dateDayjsObj.isSame(currMonthStartDayjsObj) || dateDayjsObj.isAfter(currMonthStartDayjsObj)) &&
                        (dateDayjsObj.isSame(currMonthEndDayjsObj) || dateDayjsObj.isBefore(currMonthEndDayjsObj));

                    days.push(new DayCell(date, day, isInCurrentMonth, true));
                }

                let week: Week = new Week(days);
                weeks.push(week);
            }

            return m('div.calendar', [
                (vnode.attrs.titleVisible) ?
                    m("div", { class: "text-center text-bold" }, monthYearLabel) : null,

                m("div", { class: "mt-1" },
                    [
                        m("div", { class: "d-flex align-items-center" },
                            dayLabels.map(label =>
                                m("div.calendar-cell", {
                                    class: "text-center text-muted"
                                }, m('div.my-2', label)))
                        ),
                        weeks.map(week => {
                            return m("div", { class: "d-flex align-items-center" },
                                week.days.map(dayCell => {
                                    let isSelectable = true;
                                    if (vnode.attrs.minDate != undefined && dayjs(dayCell.date).isBefore(vnode.attrs.minDate)) {
                                        isSelectable = false;
                                    }
                                    if (vnode.attrs.maxDate != undefined && dayjs(dayCell.date).isAfter(vnode.attrs.maxDate)) {
                                        isSelectable = false;
                                    }

                                    let isSelected = (dayCell.date == vnode.attrs.selectedDate);

                                    let isToday = (dayjs(dayCell.date).format("MMMM D, dddd") == dayjs(new Date()).format("MMMM D, dddd"));

                                    let isTodayAndSelected = (dayjs(dayCell.date).format("MMMM D, dddd") == dayjs(new Date()).format("MMMM D, dddd") && dayCell.date == vnode.attrs.selectedDate);

                                    if (isSelected) {
                                        isSelectable = false;
                                    }

                                    let className = "calendar-cell text-center";
                                    let innerClass = "";
                                    if (isSelectable) {
                                        className = className + " " + "calendar-cell-selectable"
                                    } else {
                                        className = className + " " + "calendar-cell-disabled"
                                    }

                                    if (isTodayAndSelected) {
                                        className = className + " " + "bg-primary text-white rounded"
                                    } else if (isSelected) {
                                        className = className + " " + "bg-primary text-white rounded"
                                    } else if (isToday) {
                                        innerClass = "triangle-shape";
                                    }

                                    if (dayCell.isInCurrentMonth == false) {
                                        className = className + " " + "calendar-cell-muted"
                                    }
                                    //let isInCurrentMonth 

                                    return m("div", {
                                        class: className,
                                        style: "position: relative;",
                                        onclick: function (event) {
                                            event.preventDefault();
                                            if (isSelectable) {
                                                vnode.attrs.onDateSelected(dayCell.date);
                                            }
                                        }
                                    }, [
                                        m("div", {
                                            class: innerClass
                                        }),
                                        m("div.my-2", {}, dayCell.day)

                                    ]
                                    )
                                })
                            )
                        })
                    ]
                )
            ]
            );
        }
    }
}


interface DateChooserAttrs {
    selectedDate?: string | null;
    maxDate?: string | null;
    minDate?: string | null;
    onDateSelected: (date: string) => void
}

export function DateChooser(): m.Component<DateChooserAttrs> {
    let currMonth: number;
    let currYear: number;
    let selectedDate: string | null = null;

    function moveToPreviousMonth() {
        if (currMonth == 1) {
            currMonth = 12;
            currYear = currYear - 1;
        } else {
            currMonth = currMonth - 1;
        }
    }

    function moveToNextMonth() {
        if (currMonth == 12) {
            currMonth = 1;
            currYear = currYear + 1;
        } else {
            currMonth = currMonth + 1;
        }
    }

    function synCurrentYearMonth(attrs: DateChooserAttrs) {
        let anchorDayjsObj: dayjs.Dayjs;
        if (attrs.selectedDate) {
            selectedDate = attrs.selectedDate;
            anchorDayjsObj = dayjs(selectedDate);
        } else {
            anchorDayjsObj = dayjs();
        }
        currMonth = anchorDayjsObj.month() + 1;
        currYear = anchorDayjsObj.year();
    }

    return {
        oninit({ attrs }) {
            //console.log("oninit: selected date :  ", attrs.selectedDate);
            synCurrentYearMonth(attrs);
        },

        view({ attrs }) {
            //console.log("view: selected date :  ", attrs.selectedDate);
            //console.log("DateChooser", attrs);

            let currMonthIndex = currMonth - 1;
            let monthYearLabel = dayjs(new Date(currYear, currMonthIndex)).format("MMMM, YYYY");

            return m('div', [
                m("div.row", [
                    m("div.col-2", { class: "text-center calendar-nav-btn" },
                        m("span", {
                            onclick: function (event) {
                                event.preventDefault();
                                moveToPreviousMonth();
                            }
                        },
                            m(CustomSvgIcon, {
                                iconType: 'caret_arrow_left',
                                themeCssClass: "svg-large svg-dark"
                            })
                        )
                    ),
                    m("div.col-8", {
                        class: "text-center text-bold lead"
                    }, monthYearLabel),
                    m("div.col-2", { class: "text-center calendar-nav-btn" },
                        m("span", {
                            onclick: function (event) {
                                event.preventDefault();
                                moveToNextMonth();
                            }
                        },
                            m(CustomSvgIcon, {
                                iconType: 'caret_arrow_right',
                                themeCssClass: "svg-large svg-dark"
                            })
                        )
                    ),
                ]),

                m(SingleMonthCalendarView, {
                    year: currYear,
                    month: currMonth,
                    titleVisible: false,
                    selectedDate: selectedDate,
                    minDate: attrs.minDate,
                    maxDate: attrs.maxDate,
                    onDateSelected: (date: string) => {
                        selectedDate = date;
                        setTimeout(() => {
                            attrs.onDateSelected(<string>selectedDate);
                            m.redraw();
                        }, 100);
                    }
                })
            ]
            );
        }
    };
}

interface DateChooserDialogAttrs extends DateChooserAttrs {
    isOpen: boolean;
    onClose: () => void
}

export function DateChooserDialog(): m.Component<DateChooserDialogAttrs> {
    let domElem: Element | null = null;

    return {
        oncreate(vnode) {
            domElem = vnode.dom;
        },

        view(vnode) {
            let attrs = vnode.attrs;

            return m("div", {
                class: attrs.isOpen ? "calendar-modal calendar-modal-shown" : "calendar-modal calendar-modal-hidden",
                onclick: (event) => {
                    if (event.target == domElem) {
                        attrs.onClose();
                    }
                }
            },
                (attrs.isOpen) ?
                    m("div.card", {
                        class: 'mr-4 calendar-modal-content',
                        onclick: (event) => { },
                    },
                        m("div.card-body",
                            [
                                m(DateChooser, {
                                    selectedDate: attrs.selectedDate,
                                    minDate: attrs.minDate,
                                    maxDate: attrs.maxDate,
                                    onDateSelected: (date: string) => {
                                        attrs.onDateSelected(date);
                                    }
                                }),

                                m("div", { class: "text-center mt-3" },
                                    m("a", {
                                        class: 'my-cal',
                                        href: "#",
                                        onclick: function (event) {
                                            event.preventDefault();
                                            attrs.onClose();
                                        }
                                    }, "Close")
                                )
                            ]
                        )
                    ) : null
            )
        }
    };
}

interface DateInputBoxAttrs {
    initialDate?: string;
    minDate?: string;
    maxDate?: string;
    size?: 'small' | 'medium'
    onDateChange: (date: string) => void;
}

export function DateInputBox(): m.Component<DateInputBoxAttrs> {
    let isCalendarVisible: boolean = false;
    let selectedDate: string = '';

    let dropdownBackgroundDOM: Element | null = null;

    return {
        oninit({ attrs }) {
            if (attrs.initialDate) {
                selectedDate = attrs.initialDate;
            }
            console.log(attrs.initialDate);
        },
        onupdate(vnode) {
            if (vnode.attrs.initialDate) {
                selectedDate = vnode.attrs.initialDate;
            }
        },

        view({ attrs }) {
            return m('span',
                [
                    //m("span", "s:" + selectedDate),

                    m('input', {
                        class: "form-control",
                        value: selectedDate,
                        onfocus: (event) => {
                            isCalendarVisible = true;
                        }
                    }),

                    m.fragment({
                        oncreate: (vnode) => {
                            //console.log('fragment created ', vnode.dom);
                            dropdownBackgroundDOM = vnode.dom;
                        }
                    },
                        [
                            m('div.calendar-dropdown-background', {
                                class: (isCalendarVisible) ? 'display-block' : 'display-none',
                                onclick: (event) => {
                                    if (event.target == dropdownBackgroundDOM) {
                                        isCalendarVisible = false;
                                    }
                                }
                            })
                        ]
                    ),

                    m('div.calendar-dropdown', {
                        class: (isCalendarVisible) ? 'display-block' : 'display-none'
                    },
                        m(DateChooser, {
                            selectedDate: selectedDate,
                            minDate: attrs.minDate,
                            maxDate: attrs.maxDate,
                            onDateSelected: (date: string) => {
                                selectedDate = date;
                                isCalendarVisible = false;
                                attrs.onDateChange(selectedDate);
                            }
                        })
                    )
                ]
            )
        }
    };
}

export function CustomDateBox(): m.Component<{
    selectedDate?: string | null,
    minDate?: string | null,
    maxDate?: string | null,
    onDateSelected: (date: string) => void
}> {
    let isSelectingDate: boolean = false;
    return {
        view(vnode) {
            let attrs = vnode.attrs;
            return [
                m("div", {
                    onclick: function (event) {
                        isSelectingDate = true;
                    }
                }, vnode.children
                ),
                m(DateChooserDialog, {
                    isOpen: isSelectingDate,
                    selectedDate: attrs.selectedDate,
                    minDate: attrs.minDate,
                    onDateSelected: (date: string) => {
                        isSelectingDate = false;
                        attrs.onDateSelected(date);
                    },
                    onClose: () => {
                        isSelectingDate = false;
                        console.log("on close is called");
                    }
                })
            ];
        }
    }
}

